export const MARK_AS_ADMIN = "Mark as Admin";
export const EDIT = "Edit";
export const REMOVE = "Remove";
export const CANCEL = "Cancel";
export const LOG_OUT = "Log Out";
// export const BASE_URL = "https://vfreportappapi-uat.azurewebsites.net";
export const BASE_URL = "https://vfapim.azure-api.net/vfuat";
export const OCP_APIM_SUBSCRIPTION_KEY = "f163f7e0679946d18031b93a1a1000a5";
export const CLIENT_ADMIN_ROLE_ID = 1;
export const USER_ROLE_ID = 2;
export const VF_ADMIN_ROLE_ID = 3;
export const dateFormate = "MMM D, YYYY";
export const timeFormate = "hh:mm A";
export const emailEncryptKey = "aC8m7Yw9sFJ4tHkL2Pq0vK5bZxW1rTjV";
// export const CLIENT_ID = "c913fe8e-39f9-47a7-806c-9546abe16cc2";
export const CLIENT_ID = "1f0a3112-4c65-40f7-9318-ce58de2d0eb0";
export const AUTH_URI = "https://app.blackbaud.com/oauth/authorize";
export const TOKEN_URI = "https://oauth2.sky.blackbaud.com/token";
export const REDIRECT_URI = window.location.href.includes("localhost")
  ? "http://localhost:3000/auth/callback"
  : "https://visualiseapp.com/auth/callback";
export const LOGOUT_URI =
  "https://app.blackbaud.com/signin/sign-out?redirectUrl=https:%2F%2Fsignin.blackbaud.com%2Fsignin%2F%3FredirectUrl%3Dhttps%253A%252F%252Fapp.blackbaud.com%252F";
export const LOGOUT_REDIRECT_URI = window.location.href.includes("localhost")
  ? "http://localhost:3000/login"
  : "https://visualiseapp.com/login";

export const BASE_URL_PBIX_REPORT =
  "https://vfpowerbiembeddtokenuat.azurewebsites.net/api/getPowerEmbedToken?code=pbk8KIUBSmihEXV9Qhf5jUbh16KL2QenSlugdftm-8XCAzFuHa5i_Q==";

export const BASE_URL_PBIX_DOWNLOAD_REPORT =
  "https://vfpowerbiexporttofileuat.azurewebsites.net/api/ExportToFile?code=P183lkI4IR7LB9-8D4F3vBtswP0khUmfHuFTmjWCiwdhAzFudqYJgg==";

export function removeSlash(str) {
  return str.replace(/\//g, "");
}

export const toastConfig = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

export const vfUserHeader = [
  { id: "name", label: "Name", minWidth: 170, align: "left" },
  { id: "email", label: "Email", minWidth: 170, align: "left" },
  {
    id: "organisation",
    label: "Organisation",
    minWidth: 170,
    align: "left",
  },
  {
    id: "access",
    label: "Access",
    minWidth: 170,
    align: "left",
  },
  {
    id: "status",
    label: "Status",
    minWidth: 170,
    align: "left",
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 100,
    align: "center",
  },
];

export const allTranslations = [
  {
    transalationId: 1,
    title: "Channel Translation",
    subTitle: "How do you categorise your Channels?",
    description:
      "Classify your organisation's marketing efforts into Fundraising Channels",
    navigate: "/channel-translation",
  },
  {
    transalationId: 2,
    title: "Program Translation",
    subTitle: "How do you categorise your fundraising Programs?",
    description:
      "Classify your organisation's marketing efforts into Fundraising Programs",
    navigate: "/program-translation",
  },
  // {
  //   transalationId: 3,
  //   title: "Appeal Category Translation",
  //   subTitle: "How do you categorise your Appeal Categories?",
  //   description: "Classify your organisation's fundraising appeals",
  //   navigate: "/appeal-category-translation",
  // },
  {
    transalationId: 8,
    title: "Fund Purpose Translation",
    subTitle: "How do you categorise your Funds?",
    description: "Classify your organisation's Funds",
    navigate: "/fundpurpose-translation",
  },
  {
    transalationId: 7,
    title: "Philanthropic Funds Translation",
    subTitle: "Tell us how you count Philanthropic Funds at your organization?",
    description: "Assign funds to be counted as Philanthropic",
    navigate: "/philanthropic-translation",
  },
  {
    transalationId: 18,
    title: "Annual Giving Translation",
    subTitle: "How do you recognise Annual Giving at your organization?",
    description: "How do you recognise donations as Annual Giving?",
    navigate: "/annualgiving-translation",
  },
  {
    transalationId: 23,
    title: "Expenses and Targets Translation",
    subTitle: "How do you recognise Annual Giving at your organization?",
    description:
      "Classify your organisation's marketing efforts into Fundraising Channels",
    navigate: "/expense-target",
  },
];

export const customFieldOptions = [
  {
    id: 1,
    fieldName: "Channel",
  },
  {
    id: 2,
    fieldName: "Vendor",
  },
];

export const campaignCustomOptions = [
  {
    id: 1,
    fieldName: "Fundraising Program",
  },
  {
    id: 2,
    fieldName: "Strategy",
  },
];

export const fundCustomOptions = [
  {
    id: 1,
    fieldName: "Fund Purpose",
  },
];

export const channelCategories = [
  {
    mainTitle: "Channel",
    title: "Appeal Categories",
    subTitle:
      "You use Appeal Categories in RE NXT to categorise Fundraising Channels",
    description:
      "You use Appeal Categories in RE NXT to categorise Fundraising Channels",
    navigate: "/appeal-categories",
    transType: "opt1",
    isDisable: false,
  },
  {
    mainTitle: "Channel",
    title: "Custom Fields Categories",
    subTitle:
      "You use Custom Fields in RE NXT to categorise Fundraising Channels",
    description:
      "You use Custom Fields Categories in RE NXT to categorise Fundraising Channels",
    navigate: "/custom-fields-categories",
    // transType: transalationId === "1" ? "opt2" : "opt3",
    transType: "opt2",
    isDisable: false,
  },
];

export const appealCategories = [
  {
    mainTitle: "Appeal Category",
    title: "Appeal Categories",
    subTitle:
      "You use Appeal Categories in RE NXT to categorise Fundraising Channels",
    description:
      "You use Appeal Categories in RE NXT to categorise Fundraising Channels",
    navigate: "/appeal-categories",
    transType: "opt1",
    isDisable: false,
  },
  {
    mainTitle: "Appeal Category",
    title: "Custom Fields Categories",
    subTitle:
      "You use Custom Fields in RE NXT to categorise Fundraising Channels",
    description:
      "You use Custom Fields Categories in RE NXT to categorise Fundraising Channels",
    navigate: "/custom-fields-categories",
    transType: "opt3",
    isDisable: false,
  },
];

export const programCategories = [
  {
    mainTitle: "Program",
    title: "Appeal Categories",
    subTitle:
      "You use Appeal Categories in RE NXT to categorise Fundraising programs",
    description:
      "You use Appeal Categories in RE NXT to categorise Fundraising programs",
    navigate: "/appeal-categories",
    transType: "opt1a",
    isDisable: false,
  },
  {
    mainTitle: "Program",
    title: "Appeal Custom Categories",
    subTitle:
      "You use Appeal Custom Categories in RE NXT to categorise Fundraising programs",
    description:
      "You use Appeal Custom Categories in RE NXT to categorise Fundraising programs",
    navigate: "/appeal-custom-categories",
    transType: "opt2a",
    isDisable: false,
  },
  {
    mainTitle: "Program",
    title: "Campaign Categories",
    subTitle:
      "You use Campaign Categories in RE NXT to categorise Fundraising programs",
    description:
      "You use Campaign Categories in RE NXT to categorise Fundraising programs",
    navigate: "/campaign-categories",
    transType: "opt1b",
    isDisable: false,
  },
  {
    mainTitle: "Program",
    title: "Campaign Custom Categories",
    subTitle:
      "You use Campaign Custom Categories in RE NXT to categorise Fundraising programs",
    description:
      "You use Campaign Custom Categories in RE NXT to categorise Fundraising programs",
    navigate: "/campaign-custom-categories",
    transType: "opt2b",
    isDisable: false,
  },
];

export const annualGiving = [
  {
    mainTitle: "AnnualGiving",
    title: "Appeal ID",
    subTitle: "You use an individual Appeal ID in RE NXT",
    description: "You use an individual Appeal ID in RE NXT",
    navigate: "/appeal-id",
    transType: "opt1a",
    isDisable: false,
  },
  {
    mainTitle: "AnnualGiving",
    title: "Appeal Category",
    subTitle: "You use an Appeal Category in RE NXT",
    description: "You use an Appeal Category in RE NXT",
    navigate: "/appeal-categories",
    transType: "opt1b",
    isDisable: false,
  },
  {
    mainTitle: "AnnualGiving",
    title: "Campaign ID",
    subTitle: "You use an individual Campaign in RE NXT",
    description: "You use an individual Campaign in RE NXT",
    navigate: "/campaign-id",
    transType: "opt2a",
    isDisable: false,
  },
  {
    mainTitle: "AnnualGiving",
    title: "Campaign Category",
    subTitle: "You use an Campaign Category in RE NXT",
    description: "You use an Campaign Category in RE NXT",
    navigate: "/campaign-categories",
    transType: "opt2b",
    isDisable: false,
  },
  {
    mainTitle: "AnnualGiving",
    title: "Dollar Threshold",
    subTitle:
      "You wish to set a Dollar value as threshold to consider donations as Annaul Giving",
    description:
      "You wish to set a Dollar value as threshold to consider donations as Annaul Giving",
    navigate: "/dollar-threshold",
    transType: "opt3",
    isDisable: false,
  },
];

export const fundPurpose = [
  {
    mainTitle: "Fundpurpose",
    title: "Fund Categories",
    subTitle: "You use Fund Categories in RE NXT",
    description: "You use Fund Categories in RE NXT",
    navigate: "/fund-categories",
    transType: "opt1",
    isDisable: false,
  },
  {
    mainTitle: "Fundpurpose",
    title: "Fund Types",
    subTitle: "You use Fund Types in RE NXT",
    description: "You use Fund Types in RE NXT",
    navigate: "/fund-types",
    transType: "opt3",
    isDisable: false,
  },
  {
    mainTitle: "Fundpurpose",
    title: "Fund Custom Fields",
    subTitle: "You use Fund Custom Fields in RE NXT",
    description: "You use Fund Custom Fields in RE NXT",
    navigate: "/fund-custom-fields",
    transType: "opt2",
    isDisable: false,
  },
];

export const subjectLineOptions = [
  {
    id: 1,
    fieldName: "Bug Report",
  },
  {
    id: 2,
    fieldName: "Suggested Improvement",
  },
];
